/**
 * Opening a new Word document from an organisation template.
 */
import { isOfficeDocumentAvailable } from "./snapshot";

/** Whether this host can open a new document from a .docx (WordApi 1.3). */
export const canCreateDocument = (): boolean => {
  try {
    return isOfficeDocumentAvailable() && Office.context.requirements.isSetSupported("WordApi", "1.3");
  } catch {
    return false;
  }
};

/**
 * Open a new Word document from a template's bytes.
 * @param base64 - The .docx, base64-encoded.
 */
export const createDocumentFromTemplate = async (base64: string): Promise<void> => {
  if (!canCreateDocument()) throw new Error("This version of Word can't create documents from the pane.");
  await Word.run(async (context) => {
    context.application.createDocument(base64).open();
    await context.sync();
  });
};
